/**
 * Billing region 모델 (BE `com.crabs.common.billing` 와 대응).
 * locale 과는 다른 개념이다 — ko 화면 + GLOBAL 결제, en 화면 + KR 결제가 모두 가능하다.
 * region 은 서버가 요청 국가로 판별하며, 프론트 값은 신뢰되지 않는다.
 */
export const BillingRegion = {
  KR: 'KR',
  GLOBAL: 'GLOBAL',
} as const;
export type BillingRegion = (typeof BillingRegion)[keyof typeof BillingRegion];

export const BillingCurrency = {
  KRW: 'KRW',
  USD: 'USD',
} as const;
export type BillingCurrency =
  (typeof BillingCurrency)[keyof typeof BillingCurrency];

export const PaymentProvider = {
  TOSS: 'TOSS',
  // BE enum(com.crabs.code.PaymentProvider)과 parity 유지. 미지원 provider 는 UI 에서 unsupported 처리.
  PAYPAL: 'PAYPAL',
  LEMON_SQUEEZY: 'LEMON_SQUEEZY',
} as const;
export type PaymentProvider =
  (typeof PaymentProvider)[keyof typeof PaymentProvider];

/** 요청 마켓 리전 ("KR" | "GLOBAL") — requestRegion.marketRegion */
export const MarketRegion = {
  KR: 'KR',
  GLOBAL: 'GLOBAL',
} as const;
export type MarketRegion = (typeof MarketRegion)[keyof typeof MarketRegion];

/** 구독 상태 (BE com.crabs.common.billing.SubscriptionStatus 와 대응) */
export const SubscriptionStatus = {
  NONE: 'NONE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELED: 'CANCELED',
} as const;
export type SubscriptionStatus =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

/** billing 마이그레이션 상태 (BE BillingMigrationStatus 와 대응) */
export const BillingMigrationStatus = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
} as const;
export type BillingMigrationStatus =
  (typeof BillingMigrationStatus)[keyof typeof BillingMigrationStatus];

export interface BillingRegionConfig {
  currency: BillingCurrency;
  provider: PaymentProvider;
}

/** KR → KRW → TOSS, GLOBAL → USD → LEMON_SQUEEZY */
export const BILLING_REGION_CONFIG: Record<BillingRegion, BillingRegionConfig> =
  {
    KR: { currency: BillingCurrency.KRW, provider: PaymentProvider.TOSS },
    GLOBAL: {
      currency: BillingCurrency.USD,
      provider: PaymentProvider.LEMON_SQUEEZY,
    },
  };
